"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$xml = void 0;
const el_1 = require("../../../node/el");
const controls_1 = require("../../../node/el/controls");
const factory_1 = require("../factory");
const lexical_1 = require("./lexical");
exports.$xml = factory_1.factory
    .withName("xml")
    .choice(c => c
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.seqEqual("<"))
    .and(r => r
    .nextIsNot(r => r.seqEqual("/")))
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^/<> ="\t\r\n]/))), "tag")
    .and(r => r
    .zeroOrMore(r => r
    .action(r => r
    .sequence(c => c
    .and(() => lexical_1.$_)
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^/<> ="\t\r\n]/))), "name")
    .and(() => lexical_1.$_)
    .and(r => r.seqEqual("="))
    .and(() => lexical_1.$_)
    .and(r => r.seqEqual("\""))
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^"]/))), "value")
    .and(r => r.seqEqual("\""))), (({ name, value }) => {
    const ret = {};
    ret[name] = value;
    return ret;
}))), "attr")
    .and(() => lexical_1.$_)
    .and(r => r.seqEqual(">"))
    .and(r => r
    .zeroOrMore(r => r
    .choice(c => c
    .or(() => exports.$xml)
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^<>]/))), "text")), (({ text, range }) => {
    return {
        value: new controls_1.__Text(text.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&apos;/g, "'"), range()),
        errors: [],
    };
}))))), "children")
    .and(r => r
    .sequence(c => c
    .and(r => r.seqEqual("</"))
    .and(() => lexical_1.$_)
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^/<> ="\t\r\n]/))), "end_tag")
    .and(() => lexical_1.$_)
    .and(r => r.seqEqual(">"))
    .and(r => r
    .assert(({ tag, end_tag }) => {
    return end_tag === tag;
}))))), (({ tag, attr, children, range }) => {
    return {
        value: new el_1.EL(tag, Object.assign({}, ...attr), children.map(c => c.value), range()),
        errors: children.map(c => c.errors).flat(),
    };
})))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.seqEqual("<"))
    .and(r => r
    .nextIsNot(r => r.seqEqual("/")))
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^/<> ="\t\r\n]/))), "tag")
    .and(r => r
    .zeroOrMore(r => r
    .action(r => r
    .sequence(c => c
    .and(() => lexical_1.$_)
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^/<> ="\t\r\n]/))), "name")
    .and(() => lexical_1.$_)
    .and(r => r.seqEqual("="))
    .and(() => lexical_1.$_)
    .and(r => r.seqEqual("\""))
    .and(r => r
    .asSlice(r => r
    .zeroOrMore(r => r.regExp(/^[^"]/))), "value")
    .and(r => r.seqEqual("\""))), (({ name, value }) => {
    const ret = {};
    ret[name] = value;
    return ret;
}))), "attr")
    .and(() => lexical_1.$_)
    .and(r => r.seqEqual("/>"))), (({ tag, attr, range }) => {
    return {
        value: new el_1.EL(tag, Object.assign({}, ...attr), [], range()),
        errors: [],
    };
}))));
exports.default = exports.$xml;
//# sourceMappingURL=$xml.js.map